// React Dependencies
import React from 'react';

// External Dependencies
import { Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

// Internal Dependencies
import PrivateRouteAdmin from '../../routing/PrivateRoute';
import LoyaltyCardInfo from './info';
import Stamps from './stamps';
import ParticipateOutlet from './participateOutlets';
import Faq from './FAQs';

const LoyaltyCardRouter = ({ match }) => (
  <Switch>
    <PrivateRouteAdmin exact path={`${match.path}`} component={LoyaltyCardInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/stampSettings`} component={Stamps} />
    <PrivateRouteAdmin exact path={`${match.path}/participatingOutlets`} component={ParticipateOutlet} />
    <PrivateRouteAdmin exact path={`${match.path}/faqs`} component={Faq} />
  </Switch>
);

LoyaltyCardRouter.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default LoyaltyCardRouter;
